import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [stage, setStage] = useState(localStorage.getItem("od_stage") || "anonymous");
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("od_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      setStage("full");
      localStorage.setItem("od_stage", "full");
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setSession = ({ token, stage: newStage, user: newUser }) => {
    if (token) localStorage.setItem("od_token", token);
    if (newStage) {
      localStorage.setItem("od_stage", newStage);
      setStage(newStage);
    }
    if (newUser) setUser(newUser);
  };

  const logout = () => {
    localStorage.removeItem("od_token");
    localStorage.removeItem("od_stage");
    setUser(null);
    setStage("anonymous");
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, stage, loading, setSession, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}
